import { encodeURLFragment } from "../utils/encodeURLFragment";

export const fileURL = (protocol, plasmidName, filePath) =>
	`${protocol}://` +
	"sequence?" +
	"source=url" +
	"&protocol=https" +
	`&name=${encodeURLFragment(plasmidName)}&path=${filePath}`;
